export default __webpack_public_path__ + "static/media/CurriculumVitaeEnglish.cd3c2dd3.pdf";